/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* Licensed under the MIT License. See LICENSE.md in the project root for license terms.
*--------------------------------------------------------------------------------------------*/

import { editor } from "monaco-editor/esm/vs/editor/editor.api";
import { Text } from "@itwin/itwinui-react";
import { DiagnosticIcon } from "./DiagnosticIcon";
import styles from "./DiagnosticListItem.module.css";

export interface DiagnosticListItemProps {
  marker: editor.IMarker;
  isSelected?: boolean;
  onClick: () => void;
}

export const DiagnosticListItem = ({ marker, isSelected, onClick }: DiagnosticListItemProps) => {
  const relatedInfo = marker.relatedInformation;

  return (
    <div className={[styles.listItem, isSelected ? styles.listItemSelected : ""].join(" ")} onClick={onClick}>
      <DiagnosticIcon category={marker.severity} />
      <div>
        {marker.message.split("\n").map((row, index, array) => {
          return (
            <div key={`${marker.resource.path}-a-${index}`}>
              {row}
              {!(relatedInfo && relatedInfo.length) && array.length - index === 1 && <LineNuber {...marker} />}
            </div>
          );
        })}
        <div>
          {relatedInfo && relatedInfo.length > 0 ?
            relatedInfo.map((info: editor.IRelatedInformation, index) => {
              return (
                <Text as="div" key={`${marker.resource.path}-b-${index}`} isMuted>
                  {info.message}<br />
                  {info.resource.path}
                  <LineNuber {...marker} />
                </Text>
              )
            }) : null
          }
        </div>
      </div>
    </div>
  );
}

const LineNuber = ({ startLineNumber, startColumn }: { startLineNumber: number, startColumn: number }) => {
  return <Text as="span" isMuted variant="small" className={styles.lineNumber}>[Ln&nbsp;{startLineNumber},&nbsp;Col&nbsp;{startColumn}]</Text>
}
